import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

const rendingResourcesCarousel = document.querySelectorAll(".fintua-story-carousel");

rendingResourcesCarousel.forEach((slider, index) => {
    const Carousel = slider.querySelector(".swiper");
    const prevArrow = slider.querySelector(".swiper-button-prev");
    const nextArrow = slider.querySelector(".swiper-button-next");

    new Swiper(Carousel, {
        modules: [Navigation],
        slidesPerView: "auto",
        centerInsufficientSlides: true,
        spaceBetween: 0,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
        },
        breakpoints: {
            1280: {
                slidesOffsetBefore: window.innerWidth >= 1180 ? (window.innerWidth - 1140) / 2 : 20,
                slidesOffsetAfter: 0,
            },
        }
    });
});
